var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoModal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "28px",
    height: "28px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(24, 22, 64)",
    d: "M14.0,27.439 C6.571,27.439 0.559,21.429 0.559,13.999 C0.559,6.571 6.571,0.559 14.0,0.559 C21.428,0.559 27.440,6.570 27.440,13.999 C27.440,21.428 21.428,27.439 14.0,27.439 ZM14.0,2.660 C7.732,2.660 2.660,7.731 2.660,13.999 C2.660,20.267 7.732,25.339 14.0,25.339 C20.267,25.339 25.339,20.267 25.339,13.999 C25.339,7.732 20.267,2.660 14.0,2.660 ZM14.0,10.526 C13.216,10.526 12.582,9.891 12.582,9.109 C12.582,8.326 13.216,7.691 14.0,7.691 C14.783,7.691 15.417,8.326 15.417,9.109 C15.417,9.891 14.783,10.526 14.0,10.526 ZM14.0,11.812 C14.580,11.812 15.49,12.282 15.49,12.862 L15.49,19.623 C15.49,20.203 14.580,20.674 14.0,20.674 C13.419,20.674 12.950,20.203 12.950,19.624 L12.950,12.862 C12.950,12.282 13.419,11.812 14.0,11.812 Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoModal);
export default __webpack_public_path__ + "static/media/infoModal.5ddba211f4cf9bc9beeccb6f647c609b.svg";
export { ForwardRef as ReactComponent };